import {
    UPDATE_FIRMWARE_DETAIL,
  } from "../actions/firmwareEdit";
  
  const defVal = {
      firmwareDetail: {
        area: '',
        cnDevices: "",
        createTime: '',
        effectiveDay: 0,
        firmwareId: '',
        firmwareLabel: "",
        firmwareLabelEn: "",
        firmwareType: "",
        firmwareUrl: "",
        firmwareVersion: "",
        grayRatio: 0,
        md5: "",
        moduleId: "",
        packageId:"",
        parameterConfig: null,
        productId: "",
        publishStatus: 1,
        publishTime: null,
        publishType: null,
        recordId: null,
        releaseNotes: "",
        releaseNotesEn: "",
        remindType: "1",
        serialProtocolUrl: "",
        size: '',
        updateTime: '',
        usDevices: '',
        userId: ""
      }

  };
  
  export default (state = defVal, action) => {
    switch (action.type) {
      case UPDATE_FIRMWARE_DETAIL:
        return Object.assign({}, state, {
          firmwareDetail: action.firmwareDetail,
        });
      default:
        return state;
    }
  };
  